import { defineComponent as T, useTemplateRef as D, createElementBlock as r, openBlock as o, Fragment as L, createElementVNode as c, createCommentVNode as m, mergeProps as h, unref as t, createVNode as k, normalizeClass as a, renderSlot as f, createBlock as p, resolveDynamicComponent as d, createSlots as y, withCtx as n, createTextVNode as u, toDisplayString as s } from "vue";
import i from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer.js";
import N from "../Tooltip/Tooltip.vue2.js";
import { CircleExclamationIcon as P } from "../../packages/icons/dist/esm/icons/circle-exclamation-icon.js";
import { CircleCheckIcon as B } from "../../packages/icons/dist/esm/icons/circle-check-icon.js";
import { TriangleExclamationIcon as E } from "../../packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import { CircleInfoIcon as S } from "../../packages/icons/dist/esm/icons/circle-info-icon.js";
import { BellIcon as H } from "../../packages/icons/dist/esm/icons/bell-icon.js";
import { useElementOverflow as V } from "../../use/index.js";
import { useOUIAProps as $ } from "../../helpers/ouia.js";
const O = {
  key: 0,
  class: "pf-v6-screen-reader"
}, K = /* @__PURE__ */ T({
  name: "PfNotificationDrawerListItem",
  __name: "NotificationDrawerListItemHeader",
  props: {
    srTitle: {},
    title: {},
    variant: { default: "custom" },
    truncateTitle: { default: 0 },
    tooltipPosition: {},
    headingLevel: { default: "h2" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(I) {
    const l = I, v = $({ id: l.ouiaId, safe: l.ouiaSafe }), w = {
      success: B,
      danger: P,
      warning: E,
      info: S,
      custom: H
    }, g = D("textRef"), C = V(g);
    return (e, R) => (o(), r(L, null, [
      c("div", h(t(v), {
        class: t(i).notificationDrawerListItemHeader
      }), [
        c("span", {
          class: a(t(i).notificationDrawerListItemHeaderIcon)
        }, [
          f(e.$slots, "icon", {}, () => [
            (o(), p(d(w[e.variant])))
          ])
        ], 2),
        k(N, { position: e.tooltipPosition }, y({
          default: n(() => [
            (o(), p(d(e.headingLevel), {
              ref: "textRef",
              class: a([t(i).notificationDrawerListItemHeaderTitle, { [t(i).modifiers.truncate]: e.truncateTitle }])
            }, {
              default: n(() => [
                e.srTitle ? (o(), r("span", O, s(e.srTitle), 1)) : m("", !0),
                u(" " + s(e.title), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          ]),
          _: 2
        }, [
          t(C) ? {
            name: "content",
            fn: n(() => [
              u(s(e.title), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["position"])
      ], 16),
      e.$slots.default ? (o(), r("div", {
        key: 0,
        class: a(t(i).notificationDrawerListItemAction)
      }, [
        f(e.$slots, "default")
      ], 2)) : m("", !0)
    ], 64));
  }
});
export {
  K as default
};
